import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classnames from 'classnames';
import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import { Motion } from 'react-motion';
import { EMPTY_ARRAY, EMPTY_OBJECT, FULL_STYLE } from '../../constants';
import { MyPureComponent, noOp } from '../../lib/react';
import { springify } from '../../lib/Motion';
import { loadImage } from '../../lib/tasks';
import Style from '../Style';
import css from './ImageLoader.css';

class ImageLoader extends MyPureComponent {
  static propTypes = {
    color: PropTypes.string,
    lqip: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
    blurRems: PropTypes.number,
    imageStyle: PropTypes.object,
  };
  static defaultProps = {
    color: Style.Colors.black,
    lqip: '',
    images: EMPTY_ARRAY,
    blurRems: 3,
    imageStyle: EMPTY_OBJECT,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      currentImage: '',
      doBlur: false,
      lqipImageLoaded: false,
    };

    this.loadedImages = new Set();
  }

  componentDidMount() {
    this.processNewProps(EMPTY_OBJECT, this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.processNewProps(this.props, nextProps);
  }

  processNewProps = (props, nextProps) => {
    const nextImages = nextProps.images.filter(Boolean);
    let currentImage = this.state.currentImage;
    let newImages = false;

    if (!isEqual(props.images, nextProps.images)) {
      newImages = true;

      if (currentImage && !nextImages.includes(currentImage)) {
        currentImage = '';
        this.setState({ currentImage: '' });
      }
    }

    if (props.lqip !== nextProps.lqip) {
      this.setState({
        doBlur: !Boolean(currentImage),
        lqipImageLoaded: false,
      });
      this.loadImages([nextProps.lqip], this.markLqipLoaded);
    }

    if (newImages) {
      this.loadedImages = new Set();
      this.loadImages(nextImages, this.checkForNextImage);
    }
  };

  loadImages = (images, thenFunc) => {
    images.map(url => {
      loadImage(url)
        .then(() => this.loadedImages.add(url))
        .then(thenFunc)
        .catch(noOp);
    });
  };

  checkForNextImage = () => {
    for (let url of this.props.images.filter(Boolean)) {
      if (this.state.currentImage === url) {
        break;
      }

      if (this.loadedImages.has(url)) {
        this.setState({ currentImage: url });
        break;
      }
    }
  };

  markLqipLoaded = () => {
    this.setState(prevState => ({
      doBlur: !Boolean(prevState.currentImage),
      lqipImageLoaded: true,
    }));
  };

  render() {
    const rootStyle = {
      backgroundColor: this.props.color,
    };

    const lqipStyle = {
      ...this.props.imageStyle,
      backgroundImage: `url(${this.props.lqip})`,
    };

    const fullQualityStyle = {
      ...this.props.imageStyle,
      backgroundImage: `url(${this.state.currentImage})`,
    };

    return (
      <div className={css.root} style={rootStyle}>
        <div
          className={classnames(css.lqipBase, {
            [css.lqipLoaded]: this.state.lqipImageLoaded,
          })}
          style={lqipStyle}
        />

        <div
          className={classnames(css.fqBase, {
            [css.fqLoaded]: this.state.currentImage,
          })}
          style={fullQualityStyle}
        />
      </div>
    );
  }
}

export default withStyles(css)(ImageLoader);

// {
//   ...fullQualityStyle,
//   opacity: tween.imageOpacity,
//   filter: `blur(${tween.blur * this.props.blurRems}rem)`,
// }



// WEBPACK FOOTER //
// ./src/components/ImageLoader/ImageLoader.js